let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bxM7V")).then(() => parcelRequire('7v6Xe'));